// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"514f602f","455":"e887f2e3","977":"50f08c71"}[chunkId] + ".chunk.js";
};